export default "__VITE_ASSET__jsaut51G__"